export default __webpack_public_path__ + "static/digital_payment-b25ac3016df8fc4336bbfd33811ebab0.png";